import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';
import { NCZIElectronicExaminationRecordType } from '../Enums/ncziElectronicExaminationRecordType.enum';
import { NCZIReference } from '../Interfaces/ncziTypes';

export type GetPatientExaminationListParams = PatientCommandParams & {
	page?: number;
	perPage?: number;
	dateFrom?: string;
	dateTo?: string;
	ownRecords?: boolean;
	types?: NCZIElectronicExaminationRecordType[];
	sensitivity?: number;
	expertise?: NCZIReference;
};

export const GetPatientExaminationList = (
	params: GetPatientExaminationListParams,
): Command => {
	return {
		// operation: 'VyhladajZaznamyOVysetreniach_v7',
		operation: 'VyhladajZaznamyOVysetreniach_v8',
		params,
	};
};
